define('Digi.knowledge.knowledge.Router'
, [
    'Backbone'
  , 'Digi.knowledge.knowledge.View'
  ]
, function
  (
    Backbone
  , DigiknowledgeView
  )
{
  'use strict';

  return Backbone.Router.extend({
    routes:
    {
      'knowledge': 'DigiknowledgeView'
    }

  , initialize: function (container)
    {
      this.application = container;
      this.UserProfile = container.getComponent('UserProfile');
    }

  , DigiknowledgeView: function ()
    {
      var self = this;
      this.UserProfile.getUserProfile().then(function (profileData)
      {
        var view = new DigiknowledgeView
        ({
          application: self.application
        , UserProfile: profileData
        })

        view.showContent();
      });
    }

  })

});
